// shadcn
import { Dialog, DialogContent, DialogHeader, DialogTitle } from 'src/@/components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'src/@/components/ui/select';
import { Label } from 'src/@/components/ui/label';
import { cn } from 'src/@/lib/utils';
import { useSnackbar } from 'notistack';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import getActionChatInfo from 'src/actions/chats/getActionChatInfo';
import getActionCriarChatAndNovaMensagem from 'src/actions/chats/getActionCriarChatAndNovaMensagem';
import getActionVerificaNumero from 'src/actions/chats/whatsapp/getActionVerificaNumero';
import v1_actionVerificarNumero from 'src/actions/v1/whatsapp/v1_actionVerificarNumero';
import v3_actionGetChannelHealth from 'src/actions/v3/chats/v3_actionGetChannelHealth';
import Iconify from 'src/components/Iconify';
import { RowInput } from 'src/components/forms/RowInput';
import { getChatsAtendimento, getCountsChats } from 'src/redux/slices/chat';
import { PATH_CHAT } from 'src/routes/paths';
import NovoChatForm from 'src/sections/@dashboard/cadastro/NovoChatForm';
import { soNumeros, validarNumeroWhatsapp } from 'src/utils/functions';

// ----------------------------------------------------------------------

export default function ModalNovoChat({
  open,
  onClose,
  listaClientesCanais,
  cliente,
  user
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar();
  const isMultisession = cliente.multiSession === 1;
  const [loadingNovoChat, setLoadingNovoChat] = useState(false);
  const [selectedClienteId, setSelectedClienteId] = useState(null);
  const [healthData, setHealthData] = useState(null);
  const [loadingHealth, setLoadingHealth] = useState(false);


  useEffect(() => {
    if (isMultisession) {
      setSelectedClienteId(listaClientesCanais[0]?.cliente_id);
    } else {
      setSelectedClienteId(cliente._id);
    }
  }, [listaClientesCanais, isMultisession, cliente._id]);

  const sessaoEscolhida = listaClientesCanais.find(item => item.cliente_id?.toString() === selectedClienteId?.toString());
  const isWhatsapp = isMultisession ? sessaoEscolhida?.platform === 'whatsapp' : cliente?.platform === 'whatsapp';

  // Buscar dados de saúde do canal (apenas WhatsApp)
  useEffect(() => {
    async function fetchHealth() {
      const clienteId = isMultisession ? selectedClienteId : cliente?._id;
      if (!clienteId || !open || !isWhatsapp) {
        setHealthData(null);
        return;
      }

      setLoadingHealth(true);
      try {
        const response = await v3_actionGetChannelHealth(clienteId, { periodo: '7d' });
        if (response.data?.error === false) {
          setHealthData(response.data.data);
        } else {
          setHealthData(null);
        }
      } catch (err) {
        console.error('Erro ao buscar saúde do canal:', err);
        setHealthData(null);
      } finally {
        setLoadingHealth(false);
      }
    }

    fetchHealth();
  }, [open, selectedClienteId, isMultisession, cliente?._id, isWhatsapp]);

  async function onCriarChat(data) {
    const { contato } = data;
    if (!contato.whatsapp || !contato.nome) {
      enqueueSnackbar(t('chat.newChat.errors.fillAllFields'), { variant: 'error' });
      return setLoadingNovoChat(false);
    }
    setLoadingNovoChat(true);
    try {
      // const querys = `?sessao=${ isMultisession ? sessaoEscolhida.sessao : cliente.sessao}&numero=${validarNumeroWhatsapp(contato.whatsapp)}&canal=whatsapp`;
      // const result_verificar_numero = await v1_actionVerificarNumero(querys);

      // if (result_verificar_numero.data.data.numberExists === false) {
      //   setLoadingNovoChat(false);
      //   enqueueSnackbar('Número não existe no whatsapp', { variant: 'error' });
      //   return;
      // } 

      const response_chat_info = await getActionChatInfo(isMultisession ? selectedClienteId : cliente._id, validarNumeroWhatsapp(contato.whatsapp));
      if (response_chat_info.data) {
        enqueueSnackbar(t('chat.newChat.errors.chatAlreadyExists'), { variant: 'warning' });
        setLoadingNovoChat(false);
      } else {
        getActionCriarChatAndNovaMensagem({
          nomeCliente: contato.nome,
          numeroCliente: validarNumeroWhatsapp(contato.whatsapp),
          statusRoom: "Atendendo",
          usuarioId: user.id,
          clienteId: isMultisession ? selectedClienteId : cliente._id
        }).then(() => {

          getActionChatInfo(isMultisession ? selectedClienteId : cliente._id, validarNumeroWhatsapp(contato.whatsapp)).then(res => {
            onClose();
            setLoadingNovoChat(false);
            navigate(`${PATH_CHAT.chat.root}`);
            dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, true));
            dispatch(getCountsChats(user.clienteId, user.id, user.setorId));
          })
        }).catch(() => setLoadingNovoChat(false));
      }

    } catch (error) {
      setLoadingNovoChat(false);
      enqueueSnackbar(t('chat.newChat.errors.createFailed'), { variant: 'error' });
      console.log(error)
    }

  }


  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className={cn("w-full sm:max-w-[420px] p-0 overflow-hidden border-border")}>
        <DialogHeader className="px-6 pt-6 pb-4 border-b bg-background">
          <DialogTitle className="text-xl font-semibold flex items-center gap-2 text-foreground">
            <Iconify icon="mdi:chat-plus-outline" className="w-[22px] h-[22px] text-violet-600" />
            {t('chat.newChat.title')}
          </DialogTitle>
        </DialogHeader>
        
        <div className="flex flex-col gap-5 p-6 bg-muted/30">
          <div className="flex flex-col gap-4">
            {isMultisession && (
              <div className="flex flex-col gap-2">
                <Label className="text-sm font-medium text-foreground">
                  {t('chat.newChat.sendChannel')} <span className="text-red-500">*</span>
                </Label>
                <Select
                  value={selectedClienteId?.toString()}
                  onValueChange={(value) => setSelectedClienteId(value)}
                >
                  <SelectTrigger className="w-full h-10 bg-background border-input transition-all">
                    <SelectValue placeholder={t('chat.newChat.selectChannel')} />
                  </SelectTrigger>
                  <SelectContent>
                    {listaClientesCanais.length > 0 && listaClientesCanais.map((option) => (
                      <SelectItem key={option.cliente_id} value={option.cliente_id?.toString()}>
                        {option.nome}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            )}

            {/* Indicador de Saúde do Canal - Apenas WhatsApp */}
            {isWhatsapp && loadingHealth ? (
              <div className="flex items-center justify-center py-4 bg-muted/50 rounded-lg border border-dashed text-muted-foreground">
                <div className="w-5 h-5 border-2 border-violet-500 border-t-transparent rounded-full animate-spin" />
                <span className="ml-3 text-sm font-medium">{t('chat.newChat.health.checking')}</span>
              </div>
            ) : isWhatsapp && healthData && (
              <div className={cn(
                "px-4 py-3 rounded-lg border shadow-sm transition-all",
                healthData.health_status === 'excelente' && "bg-green-50/50 border-green-200 dark:bg-green-950/20 dark:border-green-900",
                healthData.health_status === 'bom' && "bg-blue-50/50 border-blue-200 dark:bg-blue-950/20 dark:border-blue-900",
                healthData.health_status === 'regular' && "bg-yellow-50/50 border-yellow-200 dark:bg-yellow-950/20 dark:border-yellow-900",
                healthData.health_status === 'ruim' && "bg-orange-50/50 border-orange-200 dark:bg-orange-950/20 dark:border-orange-900",
                healthData.health_status === 'critico' && "bg-red-50/50 border-red-200 dark:bg-red-950/20 dark:border-red-900"
              )}>
                <div className="flex items-center gap-2.5">
                  <div className={cn(
                    "p-1.5 rounded-full",
                    healthData.health_status === 'excelente' && "bg-green-100 text-green-600 dark:bg-green-900/50 dark:text-green-400",
                    healthData.health_status === 'bom' && "bg-blue-100 text-blue-600 dark:bg-blue-900/50 dark:text-blue-400",
                    healthData.health_status === 'regular' && "bg-yellow-100 text-yellow-600 dark:bg-yellow-900/50 dark:text-yellow-400",
                    healthData.health_status === 'ruim' && "bg-orange-100 text-orange-600 dark:bg-orange-900/50 dark:text-orange-400",
                    healthData.health_status === 'critico' && "bg-red-100 text-red-600 dark:bg-red-900/50 dark:text-red-400"
                  )}>
                    <Iconify icon="mdi:heart-pulse" className="w-[18px] h-[18px]" />
                  </div>
                  <span className={cn(
                    "text-sm font-semibold",
                    healthData.health_status === 'excelente' && "text-green-700 dark:text-green-400",
                    healthData.health_status === 'bom' && "text-blue-700 dark:text-blue-400",
                    healthData.health_status === 'regular' && "text-yellow-700 dark:text-yellow-400",
                    healthData.health_status === 'ruim' && "text-orange-700 dark:text-orange-400",
                    healthData.health_status === 'critico' && "text-red-700 dark:text-red-400"
                  )}>
                    {t('chat.newChat.health.title')}: {t(`chat.newChat.health.status.${healthData.health_status}`, { defaultValue: healthData.health_status?.charAt(0).toUpperCase() + healthData.health_status?.slice(1) })}
                  </span>
                </div>
                {healthData.health_status === 'regular' && (
                  <div className="mt-2.5 flex items-start gap-1.5 text-xs text-yellow-600 dark:text-yellow-500 bg-yellow-100/50 dark:bg-yellow-900/20 p-2 rounded-md">
                    <Iconify icon="mdi:alert-outline" className="w-4 h-4 shrink-0" />
                    <span className="leading-snug">{t('chat.newChat.health.warnings.regular')}</span>
                  </div>
                )}
                {healthData.health_status === 'ruim' && (
                  <div className="mt-2.5 flex items-start gap-1.5 text-xs text-orange-600 dark:text-orange-500 bg-orange-100/50 dark:bg-orange-900/20 p-2 rounded-md">
                    <Iconify icon="mdi:alert-outline" className="w-4 h-4 shrink-0" />
                    <span className="leading-snug">{t('chat.newChat.health.warnings.bad')}</span>
                  </div>
                )}
                {healthData.health_status === 'critico' && (
                  <div className="mt-2.5 flex items-start gap-1.5 text-xs text-red-600 dark:text-red-400 bg-red-100/50 dark:bg-red-900/20 p-2 rounded-md">
                    <Iconify icon="mdi:alert-octagon-outline" className="w-4 h-4 shrink-0" />
                    <span className="leading-snug">{t('chat.newChat.health.warnings.critical')}</span>
                  </div>
                )}
              </div>
            )}

            <div className="pt-2">
              <NovoChatForm
                cliente={cliente}
                hideSelectEmpresa={true}
                showSignupButton={true}
                loadingNovoContato={loadingNovoChat}
                callbackAddContact={data => onCriarChat(data)}
              />
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
